/**
 * @sunday/text: the words Sunday's scripts show, taken from the theme wording file
 * (locales/<language>.json, under "sunday.js"), so they can be edited in admin
 * (Online Store → Themes → Edit default theme content) and translated.
 *
 * Liquid prints each group once as <script type="application/json" data-sunday-text="group">
 * (snippets/sunday-js-text.liquid, which lists the keys of every group).
 *   t('cart.share', { total: '₹25,999' })  →  fills {total} in the phrase.
 * A missing phrase logs a warning and shows nothing rather than the key.
 */
let words = null;

/* The wording file may hand back &amp; &quot; etc.; scripts want plain text. */
const unescape = (s) => (s.includes('&') ? s.replace(/&(amp|lt|gt|quot|#39);/g, (m, e) => ({ amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'" })[e]) : s);

function load() {
  words = {};
  if (typeof document === 'undefined') return; // Node tests: no words, no errors
  for (const el of document.querySelectorAll('script[data-sunday-text]')) {
    try {
      const g = el.dataset.sundayText;
      words[g] = Object.assign(words[g] || {}, JSON.parse(el.textContent, (k, v) => (typeof v === 'string' ? unescape(v) : v)));
    } catch (e) {
      console.warn('sunday-text: bad group', e);
    }
  }
}

export function t(key, vars) {
  if (!words) load();
  const i = key.indexOf('.');
  const g = key.slice(0, i), k = key.slice(i + 1);
  let s = words[g] && words[g][k];
  if (s == null) {
    load(); // a group printed after the first call (e.g. a section re-rendered)
    s = words[g] && words[g][k];
  }
  if (s == null) {
    console.warn('sunday-text: missing', key);
    return '';
  }
  return vars ? s.replace(/\{(\w+)\}/g, (m, v) => (v in vars ? String(vars[v]) : m)) : s;
}

/** One or many: t.n('cart.items', 3) uses cart.items_one / cart.items_other. */
t.n = (key, n, vars) => t(key + (n === 1 ? '_one' : '_other'), Object.assign({ n }, vars));
